import { base32EncodeNoPad } from "./base32";
import { canonicalBytes } from "./canonical";
import { sha256 } from "./hash";

export const STAMP_ID_LENGTH = 9;

export function deriveStampId(envelope: Record<string, unknown>): string {
  const body: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(envelope)) {
    if (k !== "stamp_id") body[k] = v;
  }
  const digest = sha256(canonicalBytes(body));
  return base32EncodeNoPad(digest).slice(0, STAMP_ID_LENGTH);
}
